import { Box, Card, CardContent, CardHeader, Collapse, Grid, IconButton, Switch, Typography } from '@mui/material';
import React, { useMemo } from 'react'
import { NotificationConfig } from './NotificationsSettings';
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import NotificationsIcon from '@mui/icons-material/Notifications';

type NotificationSettingsProps = {
    notifications: NotificationConfig[],
    handleActiveToggle: (
        categoryKey: string,
        type: string,
        active: boolean) => void,
    category: string,
    categoryKey: string,
    toggleCategory: (category: string) => void,
    expandedCategories: Record<string, boolean>,
    categoryIcon?: React.ReactNode
}

const NOTIFICATION_TYPES = [
    { key: "Push", label: "Push", icon: <NotificationsIcon /> },
    { key: "Email", label: "Email", icon: <MailOutlineIcon /> },
    //{ key: "SMS", label: "SMS", icon: <SmsIcon /> },
];

const NotificationGroup: React.FC<NotificationSettingsProps> = ({ handleActiveToggle, notifications, category, toggleCategory, expandedCategories, categoryIcon, categoryKey }) => {
    const notificationsByType = useMemo(() => {
        return notifications.reduce((acc, notification) => {
            acc[notification.name] = {
                active: notification.active
            }
            return acc;
        }, {} as Record<string, { active: boolean }>);
    }, [notifications]);

    return (
        <Grid item xs={12} sm={12} key={category}>
            <Card>
                <CardHeader
                    avatar={categoryIcon}
                    title={
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="h6" sx={{ fontWeight: "bold", cursor: "pointer" }} onClick={() => toggleCategory(category)}>
                                {category}
                            </Typography>
                            <IconButton onClick={() => toggleCategory(category)} data-testid={`expand-${categoryKey}`}>
                                {expandedCategories[category] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Box>
                    }
                />
                <Collapse in={expandedCategories[category]}>
                    <CardContent>
                        {Object.entries(notificationsByType).map(([typeName, typeData]) => {
                            const notificationType = NOTIFICATION_TYPES.find(notificationType => notificationType.label === typeName);
                            return (
                                <Box key={typeName} display="flex" alignItems="center" mb={2} justifyContent="space-between">
                                    <Box display="flex" alignItems="center">
                                        {notificationType?.icon}
                                        <Typography sx={{ ml: 1 }}>
                                            {typeName}
                                        </Typography>
                                    </Box>
                                    <Switch
                                        data-testid={`notif-${typeName}-${categoryKey}`}
                                        checked={typeData.active}
                                        onChange={() => handleActiveToggle(categoryKey, typeName, typeData.active)}
                                    />
                                </Box>
                            );
                        })}
                    </CardContent>
                </Collapse>
            </Card>
        </Grid>
    )
}

export default NotificationGroup